import { render, staticRenderFns } from "./FirstPageManage.vue?vue&type=template&id=473747a8&"
import script from "./FirstPageManage.vue?vue&type=script&lang=js&"
export * from "./FirstPageManage.vue?vue&type=script&lang=js&"
import style0 from "./FirstPageManage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports